import React from 'react'; import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import heroImage from '../assets/images/1.jpeg';
import mobileHeroImage from '../assets/images/IMG_7917.JPG.jpeg';

const Hero = () => {
    return (
        <section className="relative h-screen w-full overflow-hidden">
            <div className="absolute inset-0">
                <picture className="block w-full h-full">
                    <source media="(max-width: 767px)" srcSet={mobileHeroImage} />
                    <img
                        src={heroImage}
                        alt="Blesson and Tissymol"
                        className="w-full h-full object-cover object-center"
                    />
                </picture>
                <div className="absolute inset-0 bg-black/30 mix-blend-multiply" />
            </div>

            <div className="relative z-10 h-full flex flex-col items-center justify-center text-center text-white px-4">
                <p className="text-sm md:text-lg tracking-[0.2em] uppercase mb-4 opacity-0 animate-[fadeInUp_1s_ease-out_forwards]">You're invited to our wedding!</p>
                <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl mb-6 opacity-0 animate-[fadeInUp_1s_ease-out_0.3s_forwards]">
                    Blesson & Tissymol
                </h1>
                <p className="font-serif italic text-xl md:text-2xl opacity-0 animate-[fadeInUp_1s_ease-out_0.6s_forwards]">
                    April 27, 2026
                </p>

                <Reveal>
                    <div className="flex flex-col md:flex-row items-center justify-center gap-8 mt-12 bg-black/20 backdrop-blur-sm p-6 rounded-lg border border-white/10">
                        {/* Gallery Link */}
                        <div className="flex flex-col items-center space-y-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-wedding-gold">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                            </svg>
                            <Link to="/gallery" className="text-white hover:text-wedding-gold transition-all duration-300 font-serif italic text-lg">
                                View Photo Gallery
                            </Link>
                        </div>

                        {/* Divider */}
                        <div className="hidden md:block w-px h-16 bg-white/30"></div>

                        {/* Location Info */}
                        <div className="flex flex-col items-center space-y-1">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-wedding-gold mb-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                            </svg>
                            <h3 className="font-serif text-xl text-white">St Mary's Farone Church Parish Hall</h3>
                            {/* <p className="text-white/80 text-sm font-light">Upputhara</p> */}
                            <a
                                href="https://www.google.com/maps/search/?api=1&query=St+Mary%27s+Farone+Church+Parish+Hall+Upputhara"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-wedding-gold hover:text-white transition-colors duration-300 text-xs font-medium uppercase tracking-wider mt-2"
                            >
                                View on Map
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}; export default Hero;
